// extracted by mini-css-extract-plugin
module.exports = {"eye":"EyeMenu_eye__21bVL","open":"EyeMenu_open__1WLzN","line":"EyeMenu_line__1qlUW","btns-container":"EyeMenu_btns-container__C1NiS"};